module.exports = __webpack_public_path__ + "71bf70b8e00a234e230ac97f98d871de.png";